import type { SVGProps } from "react";
const SenecPictogramPlugCss = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 38C13 36.3431 14.3431 35 16 35C17.6569 35 19 36.3431 19 38C19 39.6569 17.6569 41 16 41C14.3431 41 13 39.6569 13 38ZM16 37C15.4477 37 15 37.4477 15 38C15 38.5523 15.4477 39 16 39C16.5523 39 17 38.5523 17 38C17 37.4477 16.5523 37 16 37Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32 35C30.3431 35 29 36.3431 29 38C29 39.6569 30.3431 41 32 41C33.6569 41 35 39.6569 35 38C35 36.3431 33.6569 35 32 35ZM31 38C31 37.4477 31.4477 37 32 37C32.5523 37 33 37.4477 33 38C33 38.5523 32.5523 39 32 39C31.4477 39 31 38.5523 31 38Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 17C7 10.5062 10.641 4.86286 15.9929 2H32.0071C37.359 4.86286 41 10.5062 41 17C41 22.4609 38.4251 27.3205 34.4231 30.4308C37.0949 31.4166 39 33.9858 39 37V38C39 42.4183 35.4183 46 31 46H17C12.5817 46 9 42.4183 9 38V37C9 33.9858 10.9052 31.4165 13.577 30.4307C12.2857 29.4272 11.1432 28.2418 10.188 26.9132C9.86567 26.4648 9.96785 25.8399 10.4163 25.5175C10.8647 25.1951 11.4896 25.2973 11.812 25.7457C14.5364 29.5353 18.9803 32 24 32C32.2843 32 39 25.2843 39 17C39 11.4431 35.9783 6.59191 31.4883 4H16.5117C12.0217 6.59191 9 11.4431 9 17C9 18.2911 9.16288 19.5426 9.46869 20.7359C9.6058 21.2709 9.28326 21.8157 8.74826 21.9528C8.21327 22.09 7.66842 21.7674 7.53131 21.2324C7.18426 19.8783 7 18.4599 7 17ZM15.9933 32C13.235 32.0036 11 34.2408 11 37V38C11 41.3137 13.6863 44 17 44H31C34.3137 44 37 41.3137 37 38V37C37 34.2409 34.7653 32.0038 32.0071 32C29.6211 33.2763 26.8951 34 24 34C21.105 34 18.379 33.2761 15.9933 32Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 5C17.3431 5 16 6.34315 16 8C16 9.65685 17.3431 11 19 11C20.6569 11 22 9.65685 22 8C22 6.34315 20.6569 5 19 5ZM18 8C18 7.44772 18.4477 7 19 7C19.5523 7 20 7.44772 20 8C20 8.55228 19.5523 9 19 9C18.4477 9 18 8.55228 18 8Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 12C11.7909 12 10 13.7909 10 16C10 18.2091 11.7909 20 14 20C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12ZM12 16C12 14.8954 12.8954 14 14 14C15.1046 14 16 14.8954 16 16C16 17.1046 15.1046 18 14 18C12.8954 18 12 17.1046 12 16Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 12C21.7909 12 20 13.7909 20 16C20 18.2091 21.7909 20 24 20C26.2091 20 28 18.2091 28 16C28 13.7909 26.2091 12 24 12ZM22 16C22 14.8954 22.8954 14 24 14C25.1046 14 26 14.8954 26 16C26 17.1046 25.1046 18 24 18C22.8954 18 22 17.1046 22 16Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26 8C26 6.34315 27.3431 5 29 5C30.6569 5 32 6.34315 32 8C32 9.65685 30.6569 11 29 11C27.3431 11 26 9.65685 26 8ZM29 7C28.4477 7 28 7.44772 28 8C28 8.55228 28.4477 9 29 9C29.5523 9 30 8.55228 30 8C30 7.44772 29.5523 7 29 7Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 25C15 22.7909 16.7909 21 19 21C21.2091 21 23 22.7909 23 25C23 27.2091 21.2091 29 19 29C16.7909 29 15 27.2091 15 25ZM19 23C17.8954 23 17 23.8954 17 25C17 26.1046 17.8954 27 19 27C20.1046 27 21 26.1046 21 25C21 23.8954 20.1046 23 19 23Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34 12C31.7909 12 30 13.7909 30 16C30 18.2091 31.7909 20 34 20C36.2091 20 38 18.2091 38 16C38 13.7909 36.2091 12 34 12ZM32 16C32 14.8954 32.8954 14 34 14C35.1046 14 36 14.8954 36 16C36 17.1046 35.1046 18 34 18C32.8954 18 32 17.1046 32 16Z"
            fill="currentColor"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25 25C25 22.7909 26.7909 21 29 21C31.2091 21 33 22.7909 33 25C33 27.2091 31.2091 29 29 29C26.7909 29 25 27.2091 25 25ZM29 23C27.8954 23 27 23.8954 27 25C27 26.1046 27.8954 27 29 27C30.1046 27 31 26.1046 31 25C31 23.8954 30.1046 23 29 23Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramPlugCss;
